import React from "react";
import ShortLinkPreviewLoader from "components/ShortLinkPreviewLoader";
import ShortLinkTestPreview from "components/ShortLinkTestPreview";

const ShortLinkPreviewContainer = ({ shortLink, loading }) => {
  return loading ? (
    <ShortLinkPreviewLoader />
  ) : (
    <ShortLinkTestPreview shortLink={shortLink} />
  );
};

export default ShortLinkPreviewContainer;
